import { SUBSCRIPTION_PRICE } from '../../constants'
import useIsReadOnly from '../../hooks/useIsReadOnly'
import { CHECKOUT_CONFIRMATION_STATUS, useCheckoutConfirmationStatus } from '../../services/api/subscription.hooks'
import { useGetUserInfo } from '../../services/api/user-info.hooks'
import { Spacing } from '../../styles'
import { icons } from '../../styles/images'
import { formatTrialEndDate, hasManageableSubscriptionStatus } from '../../utils/subscription'
import Flex from '../atoms/Flex'
import { Icon } from '../atoms/Icon'
import GTButton from '../atoms/buttons/GTButton'
import { BodySmall, TitleSmall } from '../atoms/typography/Typography'
import { ManageBillingButton, SubscribeButton } from './SubscriptionButtons'
import { Actions, Banner, Message } from './TrialUpgradeBanner'

// Replaces the old trial-ended paywall: the app stays visible, writes are blocked (see utils/readOnly).
const ReadOnlyBanner = () => {
    const isReadOnly = useIsReadOnly()
    const { data: userInfo } = useGetUserInfo()
    const checkoutConfirmationStatus = useCheckoutConfirmationStatus()

    if (!isReadOnly) return null

    const isConfirmingPayment = checkoutConfirmationStatus === CHECKOUT_CONFIRMATION_STATUS.confirming
    const shouldManageBilling =
        hasManageableSubscriptionStatus(userInfo?.subscription_status, userInfo?.is_subscribed) ||
        checkoutConfirmationStatus === CHECKOUT_CONFIRMATION_STATUS.needsBilling
    const trialEndDate = formatTrialEndDate(userInfo?.trial_ends_at)

    let title = trialEndDate ? `Trial ended ${trialEndDate} · read-only` : 'Trial ended · read-only'
    let detail = `Subscribe for ${SUBSCRIPTION_PRICE} to edit`
    if (isConfirmingPayment) {
        title = 'Confirming payment'
        detail = 'This can take a moment'
    } else if (shouldManageBilling) {
        title = 'Payment needs attention'
        detail = 'Update billing to edit'
    }

    return (
        <Banner>
            <Message gap={Spacing._8} alignItems="center">
                <Icon icon={shouldManageBilling ? icons.warning : icons.eye} color="gray" />
                <Flex column>
                    <TitleSmall>{title}</TitleSmall>
                    <BodySmall color="light">{detail}</BodySmall>
                </Flex>
            </Message>
            <Actions gap={Spacing._8} alignItems="center">
                {isConfirmingPayment ? (
                    <GTButton styleType="primary" value="Confirming..." disabled />
                ) : shouldManageBilling ? (
                    <ManageBillingButton styleType="primary" value="Update billing" />
                ) : (
                    <SubscribeButton />
                )}
            </Actions>
        </Banner>
    )
}

export default ReadOnlyBanner
